import { Col, Row } from 'antd'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { useTranslations } from 'common/language'
import { Typography } from 'common/widgets'
import classNames from '../styles.module.scss'


SchoolRating.propTypes = {
  ratings: PropTypes.array,
  large: PropTypes.bool,
}

export default function SchoolRating({
  ratings = [],
  large = false,
}) {
  const { gettext } = useTranslations()
  return (
    <div>
      {ratings.map(item => (
        <Row className={classNames.raitingTable} key={item.text}>
          <Col className={cx(classNames.raitingCol, classNames.raitingLabel, large && classNames.large)}>
            <Typography color="light-black" variant={large ? 'gray' : 'small-gray'}>{item.text}</Typography>
          </Col>
          <Col className={cx(classNames.raitingCol, classNames.raitingValue, large && classNames.large)}>
            {item.value !== null && item.value > 0 ? `${item.value.toFixed(1)} / 5` : gettext('No reviews yet')}
          </Col>
        </Row>
      ))}
    </div>
  )
}
